
/* routes */
export const routes = {
  TRANSCRIPT_VIEWER: '/',
  LOGIN: '/login',
}

/*  domain addresses */
export const domainAddresses = { };
